import * as React from 'react';
import { ArticleHeading3, ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IPriceEstimationProps {
  description: string;
  priceRangeText: string;
  priceText: string;
  title: string;
}

export const PriceEstimation: React.FC<React.PropsWithChildren<IPriceEstimationProps>> = props => {
  return (
    <div className={styles['container']} data-testid="price-estimation">
      <div className={styles['item']}>
        <div className={styles['title']}>
          <ArticleHeading3>{props.title}</ArticleHeading3>
        </div>
        <ArticleHeading1 color="text-secondary-default">{props.description}</ArticleHeading1>
      </div>

      <div className={styles['item']}>
        <div className={styles['title']}>
          <ArticleHeading3>{props.priceText}</ArticleHeading3>
        </div>
        <ArticleHeading1 color="text-secondary-default">Рыночная цена этой квартиры</ArticleHeading1>
      </div>

      <div className={styles['item']}>
        <div className={styles['title']}>
          <ArticleHeading3>{props.priceRangeText}</ArticleHeading3>
        </div>
        <ArticleHeading1 color="text-secondary-default">Диапазон цены</ArticleHeading1>
      </div>
    </div>
  );
};

PriceEstimation.displayName = 'PriceEstimation';
